import { StyleSheet } from 'react-native';
import colors from '@/constants/colors';
import { Typography } from '@/constants/typography';
import theme from '@/constants/colors';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.backgroundSecondary,
  },
  scroll: {
    flexGrow: 1,
    padding: 24,
    paddingBottom: 120,
    width: '100%',
    maxWidth: 920,
    alignSelf: 'center',
  },
  header: {
    marginBottom: 20,
  },
  title: {
    ...Typography.h1(theme.accentPrimary),
    fontSize: 34,
    marginBottom: 6,
  },
  subtitle: {
    ...Typography.body(theme.textMuted),
  },
  card: {
    marginBottom: 24,
    padding: 18,
    borderRadius: 16,
    borderWidth: 1.5,
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundSecondary,
  },
  sectionTitle: {
    ...Typography.h2(colors.accentPrimary),
    fontSize: 18,
    marginBottom: 6,
  },
  sectionSub: {
    ...Typography.body(colors.textMuted),
    fontSize: 14,
    marginBottom: 12,
  },
  starsRow: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 12,
  },
  starButton: {
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.backgroundPrimary,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
  },
  starButtonActive: {
    backgroundColor: colors.accentPrimary,
    borderColor: colors.accentPrimary,
  },
  starText: {
    ...Typography.h2(colors.textMuted),
    fontSize: 24,
  },
  starTextActive: {
    color: colors.backgroundPrimary,
  },
  addPhotoBox: {
    height: 96,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    backgroundColor: colors.backgroundPrimary,
  },
  plusSign: {
    ...Typography.h1(colors.accentPrimary),
    fontSize: 28,
  },
  photoRow: {
    flexDirection: 'row',
    marginBottom: 12,
    alignItems: 'center',
  },
  thumb: {
    width: 100,
    height: 100,
    borderRadius: 12,
    marginRight: -18,
    borderWidth: 2,
    borderColor: colors.backgroundSecondary,
    backgroundColor: colors.backgroundSecondary,
  },
  input: {
    backgroundColor: colors.backgroundPrimary,
    borderRadius: 12,
    padding: 12,
    color: colors.textPrimary,
    minHeight: 120,
    marginTop: 8,
    textAlignVertical: 'top',
  },
  bottomRow: {
    flexDirection: 'row',
    gap: 10,
    marginTop: 8,
    paddingHorizontal: 4,
    paddingBottom: 8,
  },
  backButton: {
    flex: 1,
    backgroundColor: colors.backgroundSecondary,
    paddingVertical: 14,
    borderRadius: 14,
    alignItems: 'center',
    borderWidth: 2,
    borderColor: colors.backgroundSecondaryVarient,
  },
  backText: {
    ...Typography.h2(colors.accentPrimary),
    fontSize: 15,
  },
  shareButton: {
    flex: 1,
    backgroundColor: colors.accentPrimary,
    paddingVertical: 14,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  shareButtonDisabled: {
    opacity: 0.6,
  },
  shareButtonText: {
    ...Typography.h2(colors.backgroundPrimary),
    fontSize: 15,
    fontWeight: '600',
  },
  doneButton: {
    flex: 1,
    backgroundColor: colors.accentPrimary,
    paddingVertical: 14,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  doneButtonDisabled: {
    opacity: 0.5,
  },
  doneText: {
    ...Typography.h2(colors.backgroundPrimary),
    fontSize: 15,
  },
  gradientSelector: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 16,
  },
  gradientOption: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: colors.borderSubtle,
    backgroundColor: colors.backgroundPrimary,
  },
  gradientOptionSelected: {
    borderColor: colors.accentPrimary,
    backgroundColor: colors.accentPrimary,
  },
  gradientOptionMinimal: {
    backgroundColor: '#f8f9fa',
  },
  gradientOptionSunset: {
    backgroundColor: '#ff6b6b',
  },
  gradientOptionText: {
    ...Typography.h2(colors.accentPrimary),
    fontSize: 13,
    fontWeight: '600',
  },
  gradientOptionTextSelected: {
    color: colors.backgroundPrimary,
  },
  gradientOptionTextMinimal: {
    color: '#212529',
  },
  sharePreviewContainer: {
    alignItems: 'center',
    marginBottom: 20,
    paddingVertical: 8,
  },
  showSharePreviewButton: {
    backgroundColor: colors.backgroundPrimary,
    paddingVertical: 14,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: colors.borderSubtle,
    borderStyle: 'dashed',
  },
  showSharePreviewButtonText: {
    ...Typography.h2(colors.accentPrimary),
    fontSize: 15,
    fontWeight: '600',
  },
  savingOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.45)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  savingText: {
    ...Typography.h2(colors.backgroundPrimary),
    marginTop: 16,
  },
});
